import { CONSTANTS } from '@constants';

export const GET_RULE_ENGINE_LIST_REQUESTED = 'get/GET_RULE_ENGINE_LIST_REQUESTED';
export const GET_RULE_ENGINE_LIST_SUCCESS = 'get/GET_RULE_ENGINE_LIST_SUCCESS';
export const GET_RULE_ENGINE_LIST_FAILURE = 'get/GET_RULE_ENGINE_LIST_FAILURE';

export const DELETE_CONFIG_REQUESTED = 'get/DELETE_CONFIG_REQUESTED';
export const DELETE_CONFIG_SUCCESS = 'get/DELETE_CONFIG_SUCCESS';
export const DELETE_CONFIG_FAILURE = 'get/DELETE_CONFIG_FAILURE';

export const DUPLICATE_CONFIG_REQUESTED = 'get/DUPLICATE_CONFIG_REQUESTED';
export const DUPLICATE_CONFIG_SUCCESS = 'get/DUPLICATE_CONFIG_SUCCESS';
export const DUPLICATE_CONFIG_FAILURE = 'get/DUPLICATE_CONFIG_FAILURE';

export const UPDATE_FIELD = 'dailyStreakList/UPDATE_FIELD';
export const UPDATE_TEMPLATE = 'dailyStreakList/UPDATE_TEMPLATE';
export const UPDATE_STREAKLIST = 'dailyStreakList/UPDATE_STREAKLIST';
export const UPDATE_PAGE = 'dailyStreakList/UPDATE_PAGE';
export const CLEAR_STATE = 'dailyStreakList/CLEAR_STATE';
export const UPDATE_ACTIVE_TAB = 'dailyStreakList/UPDATE_ACTIVE_TAB';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  tableData: {},
  templatesList: [],
  streakList: [],
  initialData: {
    pageNo: 0,
    title: '',
    sortBy: 'updatedTS',
    orderBy: 'desc',
    activeTab: 'my_streaks',
    streakId: '',
    streakType: '',
    headers: [
      {
        title: CONSTANTS.RULE_NAME,
        slug: 'rule_name',
        isSortable: false,
        isVisible: true,
        tooltip: false,
        center: false,
        sortByOrder: '',
        width: 150
      },
      {
        title: CONSTANTS.STREAK_NAME,
        slug: 'streak_name',
        isSortable: false,
        isVisible: true,
        tooltip: false,
        center: false,
        sortByOrder: '',
        width: 140
      },
      {
        title: CONSTANTS.TEMPLATE_TYPE,
        slug: 'template_type',
        isSortable: true,
        isVisible: true,
        tooltip: false,
        center: true,
        sortByOrder: 'desc',
        width: 110,
      },
      {
        title: CONSTANTS.STATUS_FILTER,
        slug: 'status',
        isSortable: true,
        isVisible: true,
        tooltip: true,
        center: false,
        sortByOrder: 'desc',
        width: 50,
      },
      {
        title: CONSTANTS.CREATEDBY,
        slug: 'createdby',
        isSortable: true,
        isVisible: true,
        tooltip: false,
        center: true,
        sortByOrder: '',
        width: 90,
      },
      {
        title: CONSTANTS.START_DATE,
        slug: 'start_date',
        isSortable: true,
        isVisible: true,
        tooltip: true,
        center: false,
        sortByOrder: 'desc',
        width: 150,
      },
      {
        title: CONSTANTS.ENDDATE,
        slug: 'end_date',
        isSortable: true,
        isVisible: true,
        tooltip: false,
        center: false,
        sortByOrder: 'desc',
        width: 150,
      },
      {
        title: 'Actions',
        slug: 'actions',
        isSortable: false,
        isVisible: false,
        tooltip: true,
        sortByOrder: '',
        width: 180,
      },
    ]
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_RULE_ENGINE_LIST_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
    case GET_RULE_ENGINE_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true
      };
    }
    case GET_RULE_ENGINE_LIST_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
      };
    }
    case UPDATE_FIELD: {
      const tableData = { ...state.tableData, ...action.payload };
      return { ...state, tableData };
    }
    case UPDATE_TEMPLATE: {
      const templatesList = [...action.payload];
      return { ...state, templatesList };
    }
    case UPDATE_STREAKLIST: {
      const streakList = [...action.payload];
      return { ...state, streakList };
    }
    case UPDATE_PAGE: {
      const initialData = { ...state.initialData, ...action.payload };
      return { ...state, initialData };
    }
    case UPDATE_ACTIVE_TAB: {
      const initialData = { ...state.initialData, ...action.payload };
      return { ...state, initialData };
    }
    case CLEAR_STATE: {
      return { ...initialState };
    }
    case DELETE_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case DELETE_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case DELETE_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
      };
    }
    case DUPLICATE_CONFIG_REQUESTED:
    {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
    case DUPLICATE_CONFIG_SUCCESS:
    {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true
      };
    }
    case DUPLICATE_CONFIG_FAILURE:
    {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
      };
    }
    default:
      return state;
  }
};

export const clearState = () => {
  return {
    type: CLEAR_STATE,
  };
};

export const updateFields = (payload) => {
  return {
    type: UPDATE_FIELD,
    payload,
  };
};

export const updateTemplate = (payload) => {
  return {
    type: UPDATE_TEMPLATE,
    payload,
  };
};

export const updateStreakList = (payload) => {
  return {
    type: UPDATE_STREAKLIST,
    payload,
  };
};

export const updatePage = (payload) => {
  return {
    type: UPDATE_PAGE,
    payload,
  };
};

export const updateActiveTab = (payload) => {
  return {
    type: UPDATE_ACTIVE_TAB,
    payload,
  };
};

export const getDailyStreakList = (data) => {
  return {
    types: [GET_RULE_ENGINE_LIST_REQUESTED, GET_RULE_ENGINE_LIST_SUCCESS, GET_RULE_ENGINE_LIST_FAILURE],
    promise: client => client.get(`getDailyStreakList/${data.itemsPerPage}/${data.pageNo}?searchKey=${data.title}&sortBy=${data.sortBy}&sortType=${data.orderBy}`)
  };
};

export const deleteRuleEngine = (data) => {
  return {
    types: [DELETE_CONFIG_REQUESTED, DELETE_CONFIG_SUCCESS, DELETE_CONFIG_FAILURE],
    promise: client => client.post(`deleteRuleEngine?id=${data}`)
  };
};

export const duplicateRuleEngine = (data) => {
  return {
    types: [DUPLICATE_CONFIG_REQUESTED, DUPLICATE_CONFIG_SUCCESS, DUPLICATE_CONFIG_FAILURE],
    promise: client => client.get(`duplicateRuleEngine?ruleId=${data}`)
  };
};
